module.exports = __webpack_public_path__ + "img/P12.60b9640.png";